module.exports = __webpack_public_path__ + "549a24c30ce8488c72e7b30ae2da8d46.gif";